export enum MultilingualPages {
  MANAGE_LANGUAGES = 'manage-languages',
  TRANSLATION_MANAGER = 'translation-manager',
  SETTINGS = 'settings',
  ONBOARDING = 'onboarding',
  PACKAGE_PICKER = 'package-picker',
}
